export const PDP_REVISIT_EVENT = 'pylot:pdp-revisit'

export function isPdpUrl(url?: string | null): boolean {
    if (!url) return false
    const path = url.split(/[?#]/)[0]
    return path.startsWith('/producto/')
}

export function dispatchPdpRevisit(): void {
    if (typeof window === 'undefined') return
    window.dispatchEvent(new CustomEvent(PDP_REVISIT_EVENT))
}

export function navigateToPdp(
    router: { push: (url: string) => void },
    url: string
): void {
    dispatchPdpRevisit()
    router.push(url)
}
